import { useContext } from 'react'
import { Link as ScrollLink } from 'react-scroll'

import classnames from 'classnames'

import Text, { TextSizes } from '~/components/atoms/Text/Text'

import Lozenge from '../Lozenge/Lozenge'
import { ThemeAccentContext } from '../types'

import styles from './PageNav.module.css'

export interface PageNavProps {
  isStacked?: boolean
  title?: string
  items: { title: string; slug: string; position?: number }[]
  onPageSelect?: (slug: string) => void
  variant?: 'internal' | 'page'
  activeSection?: string
  flexWrap?: boolean
}

export default function PageNav({
  title = 'Navigate',
  items = [],
  isStacked = true,
  onPageSelect,
  variant = 'page',
  activeSection,
  flexWrap = false,
}: PageNavProps) {
  const { themeAccent, themeAccentText } = useContext(ThemeAccentContext)

  const isInternal = variant === 'internal'

  return (
    <div
      className={classnames(
        styles.base,
        isStacked && styles.stackedList,
        isInternal && styles.internalBase,
        flexWrap && styles.flexWrap
      )}
      style={
        {
          '--themeAccent': themeAccent ? themeAccent : '10, 10, 10',
        } as React.CSSProperties
      }
    >
      <Text
        size={TextSizes[isInternal ? 'primaryTitleSml' : 'primaryTitleLrg']}
        Tag="h4"
        className={classnames(styles[`title${variant}`])}
      >
        <span style={{ color: `rgb(${themeAccentText})` }}>
          {title || 'Navigate'}
        </span>
      </Text>
      <div className={styles.itemList}>
        {items.map((item, idx) => {
          const itemRef = [item.slug]
          return (
            <div key={`inpage-nav- item-${idx}-${isStacked}`}>
              <ScrollLink
                to={`${itemRef.join('-')}`}
                href={`#${item.slug}`}
                key={`${item.slug} - ${idx}`}
                smooth={true}
                className={classnames(styles.link)}
                offset={-120}
                onClick={() => {
                  onPageSelect?.(item.slug)
                }}
              >
                <Lozenge
                  title={item.title}
                  reducedSize={isInternal}
                  smallOnMobile={!isStacked}
                  themeAccent={themeAccent || undefined}
                  isActive={
                    activeSection && activeSection === item.slug ? true : false
                  }
                />
              </ScrollLink>
            </div>
          )
        })}
      </div>
    </div>
  )
}
